<!-- QRCodeDisplay.vue -->
<template>
  <div class=" text-center justify-center">
    <!-- url ,color , bgcolor,size all must match what is in route.js file  -->
    <VueQRCodeComponent
      class="inline-block mr-32 mt-24 "
      :text="decodeURIComponent($route.params.url)"
      :size="$route.params.size"
      :color="decodeURIComponent($route.params.color)"
      :bg-color="decodeURIComponent($route.params.bgColor)"
      :error-level="errorLevel"
    ></VueQRCodeComponent>
    <!-- <VueQRCodeComponent
      id="aaaaaaaaaaaaaaaaa"
      class="inline-block mr-32 mt-24 "
      text="https://qrrate.chakrasuria.net/live/survey/demo"
      size="500"
      color="#000000"
      bg-color="#FFFFFF"
      error-level="L"
    >
    </VueQRCodeComponent> -->
  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    VueQRCodeComponent
  },
  data() {
    return {
      errorLevel: "L"
    };
  }
};
</script>

<style lang="scss" scoped></style>
